<template>
    <!-- 充值记录页面 -->
    <div class="record_wrap">
        <!-- 顶部导航栏 -->
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{ $t('moneybag.rechargeRecord') }}</div>
        </div>

        <!-- 充值记录列表 -->
        <div class="detail_section">
            <div class="section_title">
                <van-icon name="balance-list-o" />
                <span>充值记录</span>
            </div>

            <!-- 空状态 -->
            <van-empty :description="$t('item.noData')" v-if="listShow" />

            <!-- 记录列表 -->
            <div class="detail_list" v-else>
                <div class="detail_item" v-for="(item, index) in data" :key="index">
                    <div class="item_left">
                        <div class="item_icon income">
                            <van-icon name="arrow-up" />
                        </div>
                        <div class="item_info">
                            <div class="item_title">{{ item[lang] }}</div>
                            <div class="item_time">{{ item.time }}</div>
                        </div>
                    </div>
                    <div class="item_amount income">
                        +{{ item.money }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * 充值记录页面组件
 * 显示用户账户余额和充值明细列表
 */
import Vue from 'vue';
import Fetch from '../../utils/fetch'
import { Empty, Icon } from 'vant';

Vue.use(Empty).use(Icon);

export default {
    name: "rechargeRecord",
    /**
     * 组件数据
     * @returns {Object} 数据对象
     * @returns {string} lang - 当前语言
     * @returns {Array} data - 充值记录列表
     * @returns {boolean} listShow - 是否显示空状态
     */
    data() {
        return {
            lang: this.$i18n.locale || "zh_cn",
            data: [],
            listShow: false
        };
    },
    created() {
        this.$parent.footer('user', false);
    },
    mounted() {
        this.loadData();
    },
    methods: {
        /**
         * 加载充值记录数据
         * 获取账户余额和充值明细列表
         */
        loadData() {
            Fetch('/user/funds', {
                reason_id: 1
            }).then(r => {
                this.showError(r.data.list.length);
                this.data = r.data.list;
            });
        },
        /**
         * 显示/隐藏空状态
         * @param {number} len - 列表长度
         */
        showError(len) {
            this.listShow = len == 0;
        }
    }
};
</script>

<style lang="less" scoped>
/**
 * 充值记录页面样式
 * 采用卡片式设计，与其他页面保持一致的视觉风格
 */
.record_wrap {
    min-height: 100vh;
    background-color: #f5f5f5;
    padding-bottom: 20px;
}

/* 顶部背景 */
.red_top_bg {
    // height: 168px;
    // background-image: url(../images/user/moneybag/bg.png);
    // position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

/* 记录列表区域 */
.detail_section {
    margin: 20px 15px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    overflow: hidden;

    .section_title {
        display: flex;
        align-items: center;
        padding: 16px 20px;
        border-bottom: 1px solid #f5f5f5;

        .van-icon {
            font-size: 18px;
            color: #ff5252;
            margin-right: 8px;
        }

        span {
            font-size: 16px;
            font-weight: 600;
            color: #333;
        }
    }
}

/* 记录列表 */
.detail_list {
    .detail_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 20px;
        border-bottom: 1px solid #f5f5f5;
        transition: background 0.2s;

        &:last-child {
            border-bottom: none;
        }

        &:hover {
            background: #f9f9f9;
        }

        .item_left {
            display: flex;
            align-items: center;
            flex: 1;

            .item_icon {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 12px;

                .van-icon {
                    font-size: 18px;
                    color: #fff;
                }

                &.income {
                    background: linear-gradient(135deg, #ff6b6b 0%, #ff5252 100%);
                }
            }

            .item_info {
                .item_title {
                    font-size: 14px;
                    color: #333;
                    font-weight: 500;
                    margin-bottom: 4px;
                }

                .item_time {
                    font-size: 12px;
                    color: #999;
                }
            }
        }

        .item_amount {
            font-size: 16px;
            font-weight: 600;

            &.income {
                color: #ff5252;
            }
        }
    }
}
</style>
